import useScrollListener from '../../hooks/useScrollListener';

import MainHeader from '../../components/main-header/main-header.component';
import ContentBox from '../../components/content-box/content-box.component';
import TextAndImage from '../../components/text-and-image/text-and-image.component';

import Footer from '../../components/footer/footer.component';

import { FreeEcomSiteContainer } from './free-ecom-website.styles';

const FreeEcomSite = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);


	return(
		<FreeEcomSiteContainer  ref={contentRef}>
			<MainHeader title="" />
            <ContentBox 
                title="lll"
                text="yyy"
                buttonLink="../"
                buttonText="ttt"
            />
            <div className='content-contact-box'>
                <div className='text-and-image-box'>
					<TextAndImage 
						// img={textAndImage1.img} 
						title="lll"
						text="kjjj"
						title2="ffff"
						text2="fffff"
						txtL={true}
					/>
					<TextAndImage 
						// img={textAndImage2.img} 
						title="lkkk"
						text="ffcfg"
						title2="dfdgdf"
						text2="dfgdgf"
						txtL={false}
					/>
				</div>
                <iframe 
                    src="https://docs.google.com/forms/d/e/1FAIpQLSfOLltxm8Tylwn4yVISm4x_y365Gqtw2DP7elhzlxAGbVOulQ/viewform?embedded=true"
                    width="100%" 
                    minwidth="100%"
                    height="950" 
                    frameborder="0" 
                    marginheight="0" 
                    marginwidth="0"
                    margin="0"
                    padding="0"
                >Loading…</iframe>

{/* <iframe  width="640" height="414" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
            </div>
			<Footer />
		</FreeEcomSiteContainer>
	);
}

export default FreeEcomSite;